import React from "react";
import {Table} from "react-bootstrap";

export default ({banners}) => {
    if(!banners.length) {
        return <p>Нет баннеров</p>
    }

    return (
        <Table>
            <thead>
            <tr>
                <th>Баннер</th>
                <th style={{width: 80}}>Переходы</th>
            </tr>
            </thead>
            <tbody>
            {banners.map(banner =>
                <tr key={banner.id}>
                    <td><img src={banner.url} width="600" alt="" /></td>
                    <td>{banner.click}</td>
                </tr>
            )}
            </tbody>
        </Table>
    );
}
